import { Map, List } from 'immutable';
import { combineReducers } from 'redux-immutable'
import requestStatus from '../../constants/requestStatus'
import getCurrentWeeksArray from '../../functions/getCurrentWeeksArray';
import { dummyReducerFacory } from '../helpers';
import campaignsReducer from './campaignsReducer';


const WEEKS = getCurrentWeeksArray()

const INIT_STATE = Map();

const INIT_SUBSTATE_NEWSLETTERS  = Map({
    status: requestStatus.INITIALIZED,
    error: null,
    data: Map()
})

const weeksReducer = dummyReducerFacory(List(WEEKS))
const currentWeekReducer = dummyReducerFacory(WEEKS[1].isoWeek)

const combinedReducer = combineReducers({
    weeks: weeksReducer,
    currentWeek: currentWeekReducer,
    campaigns: campaignsReducer,
    newsletters: dummyReducerFacory(INIT_SUBSTATE_NEWSLETTERS)
});

const newsletterServerDataReducer = (state = INIT_STATE, action) => combinedReducer(state, action)

export default newsletterServerDataReducer;